<template>
  <layout :top="0">
    <!-- <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    /> -->

    <!-- 公司信息 -->
    <div class="company">
      <van-icon name="location-o" />
      <span>{{ companyInfo.name }}</span>
    </div>
    <!-- bmap -->
    <Map dim="1" />
    <!-- 人员列表 -->
    <ul v-if="$store.state.roleInfo.roleId !== '8'" class="personnel-container">
      <li v-for="item in empList" :key="item.id">
        <van-icon name="user-circle-o" class="personnel-container__icon" />
        <span class="personnel-container__name">{{ item.name }}</span>
        <span class="personnel-container__phone">{{ item.mobile }}</span>
        <van-button
          type="danger"
          size="mini"
          icon="delete-o"
          @click="handleDelPersonnelClick(item.id)"
          >删除</van-button
        >
      </li>
    </ul>
    <!-- 操作 -->
    <div v-if="$store.state.roleInfo.roleId !== '8'" class="btn">
      <van-button type="primary" block @click="handleAddPersonnelClick"
        >添加人员</van-button
      >
    </div>
    <div v-if="$store.state.roleInfo.roleId !== '8'" class="row-btn">
      <van-row gutter="16">
        <van-col span="12">
          <van-button
            block
            plain
            type="primary"
            :to="`/corgstr/${companyInfo.id}`"
          >
            组织架构
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            block
            plain
            type="primary"
            :to="`/developmentAudit/${companyInfo.id}`"
            >拓展审核</van-button
          >
        </van-col>
        <van-col span="24">
          <van-button
            block
            plain
            type="primary"
            to="/illegaReporting"
            >违法举报监督</van-button
          >
        </van-col>
      </van-row>
    </div>
  </layout>
  <!-- 添加人员 -->
  <add-personnel
    ref="addPersonnel"
    @submit-values="
      values =>
        handleAddPersonnelSubmit({ ...values, companyId: companyInfo.id })
    "
  />
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import {
  getCompanyHomeData,
  addCompanyAdmin,
  delCompanyAdmin
} from '@/api/chome'
import { getDetail } from '@/api/modifyCompany'
import { useAddPersonnel } from '@/hooks/useAddPersonnel'
import { useDelPersonnel } from '@/hooks/useDelPersonnel'
import { useGetData } from '@/hooks/useGetData'
// import BMapGL from 'BMapGL'

export default {
  name: 'CompanyHome',
  setup() {
    // 获取公司信息
    const companyInfo = ref({}) // 公司信息
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    // const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getDetail, (data) => {
    //   companyInfo.value = data
    // }, { companyId: companyId.value })
    // getDataLoading()
    const getCompanyInfo = useGetData(getDetail, data => {
      companyInfo.value = data
    })
    getCompanyInfo(companyId.value)
    // 获取人员列表
    const empList = ref([]) // 人员列表
    const getEmpList = useGetData(getCompanyHomeData, ({ companyEmpList }) => {
      empList.value = companyEmpList
    })
    getEmpList({ companyId: companyId.value })

    // 添加人员
    const {
      addPersonnel,
      handleAddPersonnelClick,
      handleAddPersonnelSubmit
    } = useAddPersonnel(addCompanyAdmin, () => {
      // 添加成功后回调
      getEmpList({ companyId: companyId.value })
    })

    // 删除人员
    const { handleDelPersonnelClick } = useDelPersonnel(delCompanyAdmin, () => {
      // 删除成功后回调
      getEmpList({ companyId: companyId.value })
    })

    return {
      addPersonnel,
      handleAddPersonnelClick,
      handleAddPersonnelSubmit,
      handleDelPersonnelClick,
      companyInfo,
      empList,
      getCompanyInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.company {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 16px;
}
.personnel-container {
  margin: 0 16px;
  li {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 10px 16px;
    border-radius: 3px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #666;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  }
  &__name {
    width: 80px;
  }
  &__phone {
    font-weight: 600;
    margin-left: 5px;
    flex: 1;
    margin-right: 10px;
  }
  &__icon {
    margin-right: 5px;
  }
}
.row-btn {
  margin: 16px;
}
.btn {
  margin: 16px;
  button {
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  }
}
.van-col {
  margin-bottom: 10px;
}
</style>
